export enum FormType {
    Default = "Default",
    Summary = "Summary"
}